import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { MouseEventHandler, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderItemQuantityPicker } from 'shared/ui/OrderItemQuantityPicker';

interface AddCatalogItemWithQtyProps {
    active: boolean;
    value: number;
    loading: boolean;
    disabledAddButton?: boolean;
    onSetValue: (value: number) => void;
    onItemToggleSelect: () => void;
}

export const AddCatalogItemWithQty = memo(
    ({
        active,
        loading,
        value,
        disabledAddButton = false,
        onSetValue,
        onItemToggleSelect,
    }: AddCatalogItemWithQtyProps) => {
        const { t } = useTranslation();
        // TODO Need to figure out if this is necessary. I think the guard of adding item to order is higher (on order level)
        // const canEditSelectedOrder = useSelector(getCanEditSelectedOrder);
        // const canAddOrderItem = useSelector(getUserCanAddOrderItem);
        // const canDeleteOrderItem = useSelector(getUserCanDeleteOrderItem);
        // const canChangeOrderItem = useSelector(getUserCanChangeOrderItem);
        // const currentOrderStatus = useSelector(getSelectedOrderStatus);
        //
        // const canEditOwnSelectedOrder = useSelector(getCanEditOwnSelectedOrder);
        //
        //
        // const canDoAction = (externalPermission: boolean) => {
        //     const canEditWithoutPermission =
        //         !currentOrderStatus || canEditOwnSelectedOrder;
        //
        //     return (
        //         (canEditSelectedOrder && externalPermission) ||
        //         canEditWithoutPermission
        //     );
        // };
        //
        // const canAdd = canDoAction(canAddOrderItem);
        // const canDelete = canDoAction(canDeleteOrderItem);
        // const canChange = canDoAction(canChangeOrderItem);
        // const showAddButton = canAdd && !active;
        // const showDelete = value === 1 && canDelete;

        const preventDefaultContainerClick: MouseEventHandler<
            HTMLDivElement
        > = (e) => {
            e.stopPropagation();
        };

        return (
            <Box
                sx={{ display: 'flex', justifyContent: 'flex-end' }}
                onClick={preventDefaultContainerClick}
            >
                {active ? (
                    <OrderItemQuantityPicker
                        showDeleteButton
                        value={value}
                        onQuantityChange={(newQuantity) => {
                            onSetValue(newQuantity);
                        }}
                        disabled={loading}
                    />
                ) : (
                    <Button
                        data-testclass="catalog-add-item-btn"
                        variant="contained"
                        size="small"
                        onClick={onItemToggleSelect}
                        disabled={loading || disabledAddButton}
                        startIcon={<Add sx={{ fontSize: '20px !important' }} />}
                        sx={(theme) => ({
                            height: '32px',
                            textTransform: 'none',
                            borderRadius: '4px',
                            paddingLeft: '8px',
                            paddingRight: '12px',
                            '& >.MuiButton-icon': {
                                marginRight: 0,
                            },
                            ...theme.typography.openSans.subtitle2,
                            ...(disabledAddButton && {
                                '&.Mui-disabled': {
                                    opacity: 1,
                                    color: '#FFF',
                                    backgroundColor: 'rgba(0, 0, 0, 0.14)',
                                    boxShadow: 'none',
                                    '& .MuiButton-startIcon': {
                                        color: 'inherit',
                                    },
                                },
                            }),
                        })}
                    >
                        {t('Add')}
                    </Button>
                )}
            </Box>
        );
    },
);
